export const reports = [
  {
    path: '/reports',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/Reports'),
    children: [
      {
        path: 'individual',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/components/ReportsIndividual'),
      },
      {
        path: 'predefined',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/reports/components/ReportsPredefined'),
      },
    ],
    redirect: '/reports/individual',
  },
]
